import { adminFleetStatusResponseSchema } from '@si/types';
import { get } from '@si/utils';
import { useQuery } from '@tanstack/react-query';

import { queryKeys } from './queryKeys';

interface Params {
  enabled?: boolean;
}

export function useAdminFleetStatus({ enabled = true }: Params = {}) {
  const { data, error, isLoading } = useQuery({
    queryKey: queryKeys.getAdminFleetStatus(),
    queryFn: () =>
      get({
        url: '/admin/fleet-status',
        schema: adminFleetStatusResponseSchema,
      }),
    enabled,
  });

  return {
    fleetStatus: data,
    error,
    isLoading,
  };
}
